import React from 'react';
import { injectIntl } from 'react-intl';
import { colorToArray, getLayout, i18nIntl, isNotEmpty, isColorBright, RGB_2_HEX } from '../../lib/ep.js';

import GameContainer from './GameContainer.js';

import StackitCanvas from '../games/StackitCanvas.js';
import ActionButton from '../builder/ActionButton.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import ActionLink from '../builder/ActionLink.js';

import StackItInstructionsCanvas from '../canvas/StackItInstructionsCanvas.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';
import { localizeFields } from '../builder/DynamicFields.js';

const Instructions = (props) => {
	const color = props.layout_props?.color?.text_color ?? '#000000';

	return (
		<StackItInstructionsCanvas
			color={color}
		/>
	)
};

const StopBarButton = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const stage = props.stage.Stage ?? false;
	if(stage === false) return null;

	const display_button = stage?.stack_button_display ?? 'always';
	if(display_button == 'hide') return null;

	const is_builder = props?.is_builder ?? false;

	const hasTouchSupport = () => {
		if(is_builder) return true;	// we display the button in builder to enable visual customization
		return ('ontouchstart' in window || navigator.maxTouchPoints > 0) ? true : false;
	};

	if(display_button == 'mobile' && !hasTouchSupport()) return null;

	if(isNotEmpty(stage, 'full_stack_button_image')) {
		const img_button_styles = {
			'--button-image':`url(${stage.full_stack_button_image})`,
		};
		if(isNotEmpty(stage, 'full_stack_button_hover_image')) {
			img_button_styles['--button-hover-image'] = `url(${stage.full_stack_button_hover_image})`;
		} else {
			img_button_styles['--button-hover-opacity'] = '0.8';
			img_button_styles['--button-hover-image'] = 'var(--button-image)';
		}

		return (
			<>
				{(isNotEmpty(stage, 'full_stack_button_hover_image')) && (
					<link rel="preload" as="image" href={stage.full_stack_button_hover_image} />
				)}

				<ButtonCollection
					style={img_button_styles}
				>
					<ActionLink
						_class={{ other:'game_rounded_button with_image' }}
						onMouseDown={() => props.gameCanvas.current.stopBar()}
					><img src={`${window.cdn_url}img/blank_1x1.png`} width='100%' alt={i18n("STOP")} /></ActionLink>
				</ButtonCollection>
			</>
		)
	}

	const button_color = stage?.stack_button_color ?? props.layout_props.color.main_color;
	const button_styles = {
		'--main-color':colorToArray(button_color),
		'--button-border-color':colorToArray(stage?.stack_border_color ?? 'rgba(0, 0, 0, 0.3)', true),
		'--button-border-width':`${parseInt(stage?.stack_border_width ?? 10)}px`,
		'--link-color':(isColorBright(RGB_2_HEX(button_color))) ? '0, 0, 0' : '255, 255, 255',
		'--link-color-hover':'var(--link-color)',
	};
 
	return (
		<ButtonCollection
			style={button_styles}
		>
			<ActionButton
				_class={{ other:'game_rounded_button wrap_text' }}
				onClick={() => props.gameCanvas.current.stopBar()}
				autotranslate={false}
			>{stage?.stack_button_label ?? i18n("STOP")}</ActionButton>
		</ButtonCollection>
	)
};

const StackItClient = ({ stage, ...props }) => {
	const layout_props = getLayout(props?.promotion ?? {});
	const final_stage = clientFinalPage(stage, props.actual_state);
	final_stage.Stage.stack_milestones = localizeFields(final_stage.Stage.stack_milestones,props.locale);
	return (
		<GameContainer
			{...props}
			stage={final_stage}
			instructions={<Instructions
				layout_props={layout_props}
				stage={stage}
				intl={props.intl}
			/>}
			game_type="stackit"
			display_attemps={false}
			auto_start_timer={false}
			display_audio_controls={true}
			instructions_has_border={false}
			instructions_classes='gui_flex_align_center'
			extra_content={<StopBarButton
				stage={stage}
				is_builder={props.is_builder}
				layout_props={layout_props}
				intl={props.intl}
			/>}
		>
			<StackitCanvas
				main_color={layout_props.color.main_color}
				locale={props.locale}
			/>
		</GameContainer>
	)
};

export default injectIntl(StackItClient);